import React from "react"
import { Stack } from "@chakra-ui/react"
import FormSection from "pages/EventShow/Forms/FormManagement/FormSection"
import { Form } from "sharedTypes"
import RSVPRadioButtons from "components/ReactHookForm/RSVPRadioButtonsField/RSVPRadioButtons"
import GuestDetails from "components/elements/GuestDetails"
import DynamicInputFields from "../DynamicInputFields"

type Props = {
  positiveAnswer: string
  negativeAnswer: string
  form: Form
  onClick?: () => void
  checkboxColor: string
  showRSVPRadioButtons?: boolean
  mergeTagEventTitle?: string
}

const GuestNameBlock = ({
  positiveAnswer, negativeAnswer, form, onClick, checkboxColor, showRSVPRadioButtons = true,
  mergeTagEventTitle,
}: Props) => (
  <FormSection onEdit={onClick} first>
    <Stack spacing={5} my={1}>
      <GuestDetails name="Guest Name" email="guest-email@example.com" />
      {showRSVPRadioButtons && (
        <RSVPRadioButtons
          defaultValue="positive"
          options={[{ label: positiveAnswer, value: "positive" }, { label: negativeAnswer, value: "negative" }]}
          name="attend"
          color={checkboxColor}
        />
      )}
    </Stack>
    <DynamicInputFields
      form={form}
      enableNameAndEmailToggle
      showTopDivider
      mergeTagEventTitle={mergeTagEventTitle}
    />
  </FormSection>
)

export default GuestNameBlock
